class MultiImageBanner {
  constructor(section) {
    this.section = section;
    this.banners = section.querySelectorAll('.image-banner');
    this.updateHeight();
    window.addEventListener('resize', () => this.updateHeight());
  }

  updateHeight() {
    if (this.section.dataset.heightMode !== 'fixed') {
      this.banners.forEach(b => b.style.minHeight = '');
      return;
    }

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const height = isMobile
      ? this.section.dataset.heightMobile
      : this.section.dataset.heightDesktop;

    this.banners.forEach(b => {
      b.style.minHeight = `${height}px`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.multi-image-banner').forEach(section => {
    new MultiImageBanner(section);
  });
});

document.addEventListener('shopify:section:load', e => {
  const section = e.target.querySelector('.multi-image-banner');
  if (section) new MultiImageBanner(section);
});

